import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enProductLocale from './en-us.json';
import zhProductLocale from './zh-cn.json';
import zhLang from 'element-ui/lib/locale/lang/zh-CN.js';
import enLang from 'element-ui/lib/locale/lang/en.js';
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang') || 'zh',
  messages: {
    en: {
      ...enProductLocale,
      ...enLang //
    },
    zh: {
      ...zhProductLocale,
      ...zhLang
    }
  }
});
const setLang = (lang) => {
  if (lang === sessionStorage.getItem('lang')) {
    return false;
  }
  const value = lang || 'zh';
  i18n.locale = value;
  sessionStorage.setItem('lang', value);
  location.reload();
};
Vue.prototype.$setLang = setLang;

export default i18n;
